const Col = (props) => (
  <div {...props} className={`col module ${props.className ? props.className : ''}`}>
    <div className="col-in module">
      { props.children }
    </div>
  </div>
)

export default Col
